webpackJsonp([40796467164290],{

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LocationPageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(93);
	
	var _seo = __webpack_require__(53);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _linkBack = __webpack_require__(97);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationPage = function LocationPage(_ref) {
	    var data = _ref.data;
	
	    var page = data.page.edges[0].node;
	    var traders = (0, _getContents.filterByLocation)((0, _getContents.stripNode)(data.traders.edges), page.location);
	    var insights = (0, _getContents.filterByLocation)((0, _getContents.stripNode)(data.allInsights.edges), page.location);
	    var locations = (0, _getContents.stripNode)(data.locations.edges);
	    var activelocations = (0, _getContents.stripNode)(data.activelocations.edges);
	    var regions = (0, _getContents.stripNode)(data.regions.edges);
	    var links = data.links.edges[0].node;
	    var layoutmodules = data.layout.modules;
	
	    var seo = {
	        title: page.introTitle,
	        description: page.intro,
	        image: ''
	    };
	    layoutmodules.forEach(function (module) {
	        if (module.__typename == 'DatoCmsMiniHero') {
	            seo.image = module.image.sizes.src;
	        }
	    });
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_seo2.default, seo),
	        _react2.default.createElement(_linkBack.LinkDown, {
	            parent: {
	                slug: '#location-map',
	                pageName: 'map'
	            }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: 'section indented-contents gray-dividers' },
	            _react2.default.createElement('div', { className: 'mt-60' }),
	            _react2.default.createElement(_components2.default, {
	                content: _extends({
	                    __typename: 'LocationHeader'
	                }, page),
	                locations: activelocations
	            }),
	            layoutmodules.map(function (module, i) {
	                return _react2.default.createElement(_components2.default, {
	                    key: i,
	                    content: _extends(module, page),
	                    insights: insights,
	                    locations: locations,
	                    regions: regions,
	                    traders: traders
	                });
	            })
	        ),
	        _react2.default.createElement(_components2.default, {
	            content: {
	                __typename: 'DatoCmsGiantLinkContainer',
	                links: [links]
	            }
	        })
	    );
	};
	
	exports.default = LocationPage;
	var LocationPageQuery = exports.LocationPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-location-template-js-d46646ba92241ab4b8be.js